//Primary

const ecogreen = {
  100: "#E6EDEB",
  200: "#CDDAD7",
  300: "#9AB5AF",
  400: "#689088",
  500: "#356B60",
  600: "#034638",
  700: "#02382D",
  800: "#022A22",
  900: "#011C16",
  contrastDefaultColor: "#ffffff"
}

export default ecogreen
